import { ExceptionType, IBufferMessage, IException, IType, MessageType, TypeCategory, IFilter } from '@augloop/schemas/dist/src/client/schemas';

export interface IPubSubMessage extends IBufferMessage {
    // Payload has type 'any' after deserializing IBufferMessage payload
    payload?: any;
    correlationVector?: any;
}

export const exceptionSchema: IType = {
    category: TypeCategory.Schema,
    schema: {
        name: 'Exception',
        path: 'message-schema.proto'
    }
};

export const filterWorkflowSchema: IType = {
    category: TypeCategory.Schema,
    schema: {
        name: 'Filter',
        path: 'message-schema.proto'
    }
};

export const getMessageExceptionDescription = (message: IPubSubMessage, verbose: boolean = false): string => {
    if (message == null) {
        return 'Invalid message passed';
    } else if (message.payload == null) {
        return `${ExceptionType[ExceptionType.NoOutput]}: Payload is null`;
    } else if (message.payload.exceptionType == null) {
        return 'Payload is not an exception';
    } else {
        let description = ExceptionType[message.payload.exceptionType]; // Exception type
        description += message.payload.message ? `: ${message.payload.message}` : ': No description'; // Exception message
        description += (verbose && message.payload.data) ? `\n${message.payload.data.toString()}` : ''; // Exception data
        return description;
    }
};

export const getMessageExceptionType = (message: IPubSubMessage): ExceptionType => {
    if (message == null || message.payload == null || message.payload.exceptionType == null) {
        return ExceptionType.Unknown;
    }

    return message.payload.exceptionType;
};

export const setMessageException = (message: IPubSubMessage, error: IException): void => {
    if (message == null) {
        throw new Error('Cannot set exception on null message');
    }

    message.payload = error;
    message.payloadSchema = exceptionSchema;
    message.messageType = MessageType.Exception;
};

export const isExceptionMessage = (message: IPubSubMessage): boolean => {
    if (message == null || message.messageType == null) {
        return true;
    }

    return (message.messageType == MessageType.Exception);
};

export const setStopAndFilterWorkflowMessage = (message: IPubSubMessage, filter?: string): void => {
    if (message == null) {
        throw new Error('Cannot set filter on null message');
    }

    const filterMessage: IFilter = {
        condition: filter
    };
    message.payload = filterMessage;
    message.payloadSchema = filterWorkflowSchema;
    message.messageType = MessageType.StopAndFilterWorkflow;
};

export const isStopWorkflowMessage = (message: IPubSubMessage): boolean => {
    return (message || {}).messageType == MessageType.StopAndFilterWorkflow;
};
